/**
 * Created by Owner on 2016/8/9.
 */
import { Component } from '@angular/core';
import { NavController, AlertController, ViewController, NavParams, LoadingController } from 'ionic-angular';
import { AppConfigService } from "../../services/appConfig.service";
import { BetDetailsPage } from "../betDetails/betDetails";
import { UserService } from "../../services/user.services";
import { BetDetailsBauCuaPage } from "../betDetailsBauCua/betDetailsBauCua";
import { LoginPage } from '../login/login';

//和投注历史的样式相同
@Component({
    templateUrl: 'balanceChangeList.html',
    selector: 'balance-change-list-page'
})
export class BalanceChangeListPage {
    private recordList: any = [];
    private infiniteScrollBoolean: boolean = true;
    private totalNum: number = 0;
    requestData: any;
    inCome: number;
    pay: number;
    wallettype: number;
    constructor(
        private navParams: NavParams,
        private nav: NavController,
        private alertCtrl: AlertController,
        private userService: UserService,
        public viewCtrl: ViewController,
        private loadingCtrl: LoadingController) {
        this.requestData = navParams.get("requestData");
        this.loadingData(navParams.get("data"));
        this.wallettype = LoginPage.wallettype
    }

    goDetail(index: string, lotteryID: number) {
        if (lotteryID === 92 || lotteryID === 93 || lotteryID === 94) {
            this.nav.push(BetDetailsBauCuaPage, {
                betID: index,
                gameID: lotteryID
            });
        } else if (index.indexOf("B") == 0) {
            this.nav.push(BetDetailsPage, {
                betId: index
            });
        }
    }

    doRefresh(refresher) {
        this.getFirstData(refresher);
    }

    getFirstData(refresher: any = null) {
        let dataParams = this.requestData;
        this.userService.balanceChangeSearch(dataParams, this.alertCtrl).then(data => {
            if (!data["msg"]) {
                this.loadingData(data);
                if (refresher) {
                    refresher.complete();
                    this.infiniteScrollBoolean = true;
                }
            }
        });
    }

    doInfinite(infiniteScroll) {
        let dataParams = this.requestData;
        infiniteScroll.enable(false);
        setTimeout(() => {
            this.userService.balanceChangeSearchNext(dataParams, this).then(data => {
                if (!data["msg"]) {
                    this.pay = data["pay"];
                    this.inCome = data["income"];
                    data["reslist"].map(item => {
                        item["bettime"] = item["opttime"].replace(/-/g, '/').substr(0, 11);
                        if (LoginPage.wallettype == 1) {
                            if (item["pay"] != 0) {
                                item["balance"] = Number(item["pay"]).toFixed(2);
                            } else {
                                item["balance"] = Number(item["income"]).toFixed(2);
                            }
                            
                        } else {
                            item["balance"] = Number(item["afterbalance"] - item["beforebalance"]).toFixed(4);
                            item["balance"] = item["balance"] > 0 ? ("+" + item["balance"]) : item["balance"];
                        }
                        item["balanceState"] = item["balance"] > 0;
                        item["betinfo"] = item["wid"].indexOf("B") == 0;
                        return item;
                    });
                    
                    this.recordList = this.recordList.concat(data["reslist"]);
                    this.totalNum = data["totalrecord"];
                    infiniteScroll.complete();
                    infiniteScroll.enable(true);
                } else {
                    infiniteScroll.enable(true);
                    this.infiniteScrollBoolean = false;
                }
            });
        }, 500);
    }

    //更新加工数据
    loadingData(data: any) {
        this.recordList = data["reslist"];
        this.pay = data["pay"];
        this.inCome = data["income"];
        this.recordList.map(item => {
            item["bettime"] = item["opttime"].replace(/-/g, '/').substr(0, 11);
            item["balanceState"] = item["balance"] > 0;

            // if (LoginPage.wallettype == 1) {
            //     if (item["pay"] != 0) {
            //         item["balance"] = Number(item["pay"]).toFixed(2);
            //     } else {
            //         item["balance"] = Number(item["income"]).toFixed(2);
            //     }
            //     console.log('item["balance"]',item["balance"]);
                
            // } else {
            //     item["balance"] = Number(item["afterbalance"] - item["beforebalance"]).toFixed(4);
            //     item["balance"] = item["balance"] > 0 ? ("+" + item["balance"]) : item["balance"];
            // }

            if (item["pay"] != 0) {
                item["balance"] = Number(item["pay"]).toFixed(2);
            } else {
                item["balance"] = Number(item["income"]).toFixed(2);
            }

            item["betinfo"] = item["wid"].indexOf("B") == 0;
            // console.log('item',item);
            
            return item;
        });
        this.totalNum = data["totalrecord"];
    }

}



// WEBPACK FOOTER //
// ./src/pages/balanceChangeList/balanceChangeList.ts